import { InputContentPart, Message } from '@ag-ui/core';
import { isString } from 'lodash';

/**
 * The text of a user turn. AG-UI allows content to be multimodal parts as well as a
 * plain string; only text can go on the wire as a prompt, so anything else is dropped.
 */
export function userText(content: string | InputContentPart[]): string {
  if (isString(content)) {
    return content;
  }
  return content
    .filter(part => part.type === 'text')
    .map(part => part.text)
    .join('\n');
}

/**
 * The turn being asked, as the request's `prompt`. The gateway holds the conversation
 * itself (see `AskPromptRequest.threadId`), so a request carries only the newest question.
 *
 * Anything after the newest user message is ignored: at request time the message just
 * added by `send` is always last, and the only other producer (the dev sample-html
 * command) never issues a request.
 */
export function lastUserPrompt(messages: Message[]): string {
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    const message = messages[i];
    if (message.role === 'user') {
      // A user turn with no text at all (an image on its own) yields no prompt rather
      // than falling further back, which would silently re-ask an older question.
      return userText(message.content);
    }
  }
  return '';
}
